// extracted by mini-css-extract-plugin
export default {"lightMode":"App_lightMode__OPyzv","darkMode":"App_darkMode__Yqk2A"};